/**
 * moduł trzymający informacje o validacji
	*@module validate
*/
app.service('validate', function (front, passwordInvalid, console, scroll) {
	var rules = {
		email: {
			required: true,
			email: true,
			maxlength: 200
		},
		email2: {
			email: true
		},
		emailRepeat: {
			required: true,
			email: true,
			equalTo: "#email"
		},
		recaptcha: {
			required: true
		},
		passwordOld: {
			required: true
		},
		login: {
			required: true
		},
		password: {
			required: true,
			minlength: 5
		},
		strongPassword: {
			strongPassword: true
		},
		passwordNewRepeat: {
			required: true,
			equalTo: "#password"
		},
		firstname: {
			required: true,
			minlength: 2,
			firstname: true
		},
		surname: {
			required: true,
			minlength: 2,
			surname: true
		},
		userType: {
			required: true
		},
		countryCode: {
			required: true
		},
		zipCode: {
			required: true,
			zipCode: true
		},
		phone: {
			required: true,
			phone: true
		},
		notRequiredPhone: {
			required: false,
			phone: true
		},
		city: {
			required: true,
			minlength: 2,
			maxlength: 40,
			city: true
		},
		street: {
			required: true,
			minlength: 2,
			maxlength: 60,
			street: true
		},
		nip: {
			required: true,
			nip: true
		},
		vatUe: {
			required: true,
			vatUe: true,
			viesVerified: true
		},
		numberId: {
			maxlength: 50,
			required: true,
			numberId: true
		},
		internalId: {
			required: true,
			internalId: true
		},
		percentageShare: {
			required: true,
			percentageShare: true
		},
		roleDescription: {
			required: true,
			maxlength: 256
		},
		companyName: {
			required: true,
			maxlength: 160,
			companyName: true
		},
		employeeName: {
			required: true,
			minlength: 2,
			maxlength: 80,
			employeeName: true
		},
		houseNumber: {
			required: true,
			maxlength: 10,
			houseNumber: true
		},
		flat: {
			maxlength: 10,
			flat: true
		},
		termsAccepted: {
			required: true
		},
		legalStatement: {
			required: true
		},
		requestToProvideDigitalTypeProductAtOnceNoticeAccepted: {
			required: true
		},
		requestToProvideServiceAtOnceNoticeAccepted: {
			required: true
		},
		digitalProductTypeProductRegulationsAccepted: {
			required: true
		},
		digitalProductTypeRecurringPaymentsRegulationsAccepted: {
			required: true
		},
		warrantyRegulations: {
			required: true
		},
		warrantySubscriptionRegulations: {
			required: true
		},
		shopCode: {
			required: true,
			minlength: 2
		},
		cityCode: {
			required: true,
			min: 1
		},
		parcelPointCode: {
			required: true
		},
		parcelMachineCode: {
			required: true
		},
		pofficeZipCode: {
			zipCode: true
		},
		postCityCode: {
			required: false
		},
		messageTextarea: {
			required: true
		},
		parcelMachineCity: {
			required: true
		},
		ePaymentBank: {
			required: true
			// required: "#row3:checked"
		},

		paymentType: {
			required: true
		},
		deliveryType: {
			required: true
		},
		deliveryTimeGroup: {
			required: true
		},
		interval: {
			required: true
		},
		deliveryCostAccepted: {
			required: true
		},
		notice: {
			required: true,
			email: true
		},
		questionEdit: {
			required: true,
			minlength: 3
		},
		answerEdit: {
			required: true,
			minlength: 3
		},
		complaintReason: {
			required: true
		},
		complaintDescription: {
			required: true
		},
		giftCardValue: {
			required: true,
			min: 10,
			max: 10000
		},
		giftCardNumber: {
			required: true,
			digits: true,
			minlength: 21,
			maxlength: 21
		},
		giftCardPin: {
			required: true,
			digits: true,
			minlength: 4,
			maxlength: 4
		},
		localization: {
			required: true
		},
		voucherCode: {
			voucherCode: true
		},
		captcha: {
			required: true
		}
	};
	var messages = {
		firstname: {
			required: "Podaj imię",
			minlength: "Imię jest za krótkie"
		},
		surname: {
			required: "Podaj nazwisko",
			minlength: "Nazwisko jest za krótkie"
		},
		employeeName: {
			required: "Podaj Imię i nazwisko pracownika",
			minlength: "Imię i nazwisko jest za krótkie"
		},
		userType: {
			required: "Wybierz sposób zakupów"
		},
		countryCode: {
			required: "Wybierz kraj"
		},
		zipCode: {
			required: "Podaj kod pocztowy"
		},
		city: {
			required: "Podaj miejscowość",
			minlength: "Miasto jest za krótkie",
			maxlength: "Pole może zawierać maksymalnie 40 znaków",
		},
		phone: {
			required: "Podaj numer telefonu"
		},
		street: {
			required: "Podaj ulicę",
			minlength: "Ulica jest za krótka",
			maxlength: "Pole może zawierać maksymalnie 60 znaków",
		},
		companyName: {
			required: "Podaj nazwę firmy",
			maxlength: "Pole może zawierać maksymalnie 160 znaków"
		},
		nip: {
			required: "Podaj NIP"
		},
		vatUe: {
			required: "Podaj numer VAT UE"
		},
		numberId: {
			required: "Podaj Numer ID",
			maxlength: "Pole może zawierać maksymalnie 50 znaków",
		},
		internalId: {
			required: "Podaj ID Wewnętrzne"
		},
		percentageShare: {
			required: "Podaj Udział"
		},
		roleDescription: {
			required: "Podaj Opis roli"
		},
		houseNumber: {
			required: "Podaj numer domu",
			maxlength: "Pole może zawierać maksymalnie 10 znaków"
		},
		flat: {
			flat: "Uzupełnij pole poprawnie",
			maxlength: "Pole może zawierać maksymalnie 10 znaków"
		},
		password: {
			required: "Podaj hasło",
			minlength: "Hasło ma minimum {0} znaków"
		},
		login: {
			required: "Podaj login"
		},
		passwordOld: {
			required: "Podaj swoje hasło"
		},
		passwordNewRepeat: {
			required: "Powtórz hasło",
			equalTo: "Hasła muszą być identyczne"
		},
		email: {
			required: "Wpisz adres e-mail",
			email: "Wpisz poprawny adres e-mail",
			maxlength: "Podany adres e-mail jest za długi"
		},
		email2: {
			email: "Podaj poprawnego e-maila albo pozostaw pole puste"
		},
		emailRepeat: {
			required: "Powtórz adres e-mail",
			email: "Powtórz poprawny adres e-mail",
			equalTo: "Podane adresy nie są identyczne"
		},
		recaptcha: {
			required: "Prosimy zaznacz nie jestem robotem"
		},
		termsAccepted: {
			required: "Akceptacja Regulaminu jest wymagana"
		},
		legalStatement: {
			required: "Akceptacja oświadczenia jest wymagana"
		},
		requestToProvideDigitalTypeProductAtOnceNoticeAccepted: {
			required: "Rezygnacja z prawa do odstąpienia od umowy jest niezbędna do udostępnienia produktu cyfrowego bezpośrednio po zakupie"
		},
		requestToProvideServiceAtOnceNoticeAccepted: {
			required: "Złożenie oświadczenia jest niezbędne do realizacji usługi przed upływem 14 dni"
		},
		digitalProductTypeProductRegulationsAccepted: {
			required: "Potwierdzenie zapoznania się z regulaminem produktu jest wymagane"
		},
		digitalProductTypeRecurringPaymentsRegulationsAccepted: {
			required: "Potwierdzenie zapoznania się z regulaminem płatności cyklicznych jest wymagane"
		},
		warrantyRegulations: {
			required: "Zapoznaj sie z warunkami ubezpieczenia"
		},
		warrantySubscriptionRegulations: {
			required: "Zapoznaj się z Regulaminem płatności cyklicznej"
		},
		shopCode: {
			required: front.euro ? "Wybierz sklep, w którym chcesz odebrać Towary" : "Wybierz punkt odbioru, w którym chcesz odebrać Towary",
			minlength: front.euro ? "Wybierz sklep, w którym chcesz odebrać Towary" : "Wybierz punkt odbioru, w którym chcesz odebrać Towary"
		},
		cityCode: {
			required: "Wybierz miejscowość, w której chcesz odebrać Towary",
			min: "Wybierz miejscowość, w której chcesz odebrać Towary"
		},
		parcelMachineCode: {
			required: "Wybierz Paczkomat®"
		},
		parcelPointCode: {
			required: "Wybierz punkt odbioru "
		},
		messageTextarea: {
			required: "Wiadomość nie może być pusta"
		},
		parcelMachineCity: {
			required: "Wybierz miejscowość, w której chcesz odebrać Towary"
		},
		ePaymentBank: {
			required: "Wybierz bank, w którym posiadasz internetowe konto osobiste"
		},

		paymentType: {
			required: "Wybierz rodzaj płatności"
		},
		deliveryType: {
			required: "Wybierz sposób zakupu"
		},
		deliveryTimeGroup: {
			required: "Wybierz termin dostawy"
		},
		deliveryCostAccepted: {
			required: "Zaakceptuj warunki dostawy"
		},
		notice: {
			required: "Wpisz adres e-mail",
			email: "Wpisz poprawny adres e-mail"
		},
		questionEdit: {
			required: "Podaj treść pytania",
			minlength: "Pole powinno zawierać conajmniej 3 znaki"
		},
		answerEdit: {
			required: "Podaj treść odpowiedzi",
			minlength: "Pole powinno zawierać conajmniej 3 znaki"
		},
		complaintReason: {
			required: "Wybierz powód reklamacji"
		},
		complaintDescription: {
			required: "Opis nie może być pusty"
		},
		giftCardValue: {
			required: "Wybierz wartość Karty Podarunkowej",
			min: "Minimalna wartość karty to 10zł",
			max: "Maksymalna wartość karty to 10000zł"
		},
		giftCardNumber: {
			required: "Wprowadź numer i PIN Karty Podarunkowej",
			digits: "Wprowadzony numer zawiera niedozwolone znaki",
			minlength: "Podaj poprawny numer Karty Podarunkowej (21 cyfr)",
			maxlength: "Podaj poprawny numer Karty Podarunkowej (21 cyfr)"
		},
		giftCardPin: {
			required: "Wprowadź numer i PIN Karty Podarunkowej",
			digits: "Wprowadzony PIN zawiera niedozwolone znaki",
			minlength: "Podaj poprawny pin Karty Podarunkowej (4 cyfry)",
			maxlength: "Podaj poprawny pin Karty Podarunkowej (4 cyfry)"
		},
		voucherCode: {
			voucherCode: "Kod rabatowy zawieran niedozwolone znaki"
		},
		captcha: {
			required: "Przepisz tekst z obrazka"
		}
	};
	var defaults = {
		onfocusout: function (element) {
			this.element(element);
		},
		highlight: function (element, errorClass, validClass) {
			if (element.type === "radio") {
				this.findByName(element.name).addClass(errorClass).removeClass(validClass);
			} else {
				$(element).addClass(errorClass).removeClass(validClass);
			}
			removeBackendError($(element));
		},
		unhighlight: function (element, errorClass, validClass) {
			if (element.type === "radio") {
				this.findByName(element.name).removeClass(errorClass).addClass(validClass);
			} else {
				$(element).removeClass(errorClass).addClass(validClass);
			}
			removeBackendError($(element));
		},
		ignore: ".ignore",
		success: function ($error, element) {
			let $box = false;
			let $element = $(element);
			//console.log(7777777777, $error, $element)
			if ($element.closest('.row-input').length) {
				//console.log('success:1');
				$box = $element.closest('.validate-target');
			} else if ($element.closest('.checkbox-css').length) {
				//console.log('success:2');
				$box = $element.closest('.validate-target');
			} else if ($element.closest('.e-payment-banks-list').length) {
				//console.log('success:3');
				$box = $element.closest('.row');
			} else if ($element.closest('.delivery-time-hour-list').length) {
				//console.log('success:5');
				$box = $element.closest('.delivery-time-hour-list');
				$error = $('#interval-error');
			} else if ($error.is('#inpost-point-error') || $element.is('#parcel-point-code-error')) {
				//console.log('success:7a', $error, element);
				$box = $('#delivery-points #delivery-points-list');
			} else if ($error.is('#delivery-point-localization-error')) {
				//console.log('success:7b', $error, element);
				//$box = $('#delivery-points > .delivery-points-search .search-box');
			} else if ($error.closest('.radio-group').length) {
				//console.log('success:4');
				$box = $error.closest('.radio-group');
			} else if ($element.closest('.row-textarea').length) {
				//console.log('success:9');
				$box = $element.closest('.validate-target');
			} else if ($error.closest('.validate-target').length) {
				//console.log('success:6');
				$box = $error.closest('.validate-target');
			} else {
				//console.log('success:8', $error, element);
				if ($element.length) {
					$box = $element.closest('.validate-target');
				}
			}


			if ($box && $box.length) {
				$box.addClass('validate-ok').removeClass('validate-error');
			}
			if ($error.length) {
				$error.remove();
			}
		},
		invalidHandler: function (form, validator) {
			if (!$(form.target).closest('.remodal-wrapper').length) {		//jeśli bład występuje na warstwie to nie przesuwamy
				if (validator.errorList.length && validator.errorList[0].element) {
					let element = validator.errorList[0].element;
					let $elementToScroll;
					let offset = 0;
					if (element.name == 'deliveryType') {
						$elementToScroll = $(element).closest('.delivery');
					} else if (element.name == 'interval') {
						$elementToScroll = $('.delivery-time-hour-list');
					} else if (element.name == 'delivery.shopCode') {
						$elementToScroll = $('#shops').length ? $('#shops') : $('#shops-list');		// sklepy lub w przypadku taxfree komunikat błędu
					} else if (element.name == 'delivery.localization') {
						$elementToScroll = $('#delivery-points');
					} else if ($(element).hasClass('js-selected-bank')) {
						$elementToScroll = $('#e-transfer-banks');
					} else if ($(element).hasClass('delivery-time-group') || $(element).hasClass('delivery-group')) {
						$elementToScroll = $('.delivery-time');
					} else {
						$elementToScroll = $(element).parent();
						offset = 50;
					}
					if ($elementToScroll && $elementToScroll.length) {
						let top = $elementToScroll.offset().top;
						let height = $elementToScroll.height();
						let bottom = top + height;
						if (!(top > window.scrollY && bottom < window.scrollY + window.innerHeight)) {	// przesuwamy kiedy element wykracza poza ekran. Jeśli mieści się na ekranie to nie przesuwamy
							console.log('invalidHandler, skrolowanie do: ', $elementToScroll, element)
							scroll.to({
								$element: $elementToScroll,
								speed: 200,
								offsetTop: offset
							});
						} else {
							console.log('nie robimy scrolla')
						}
					}
				}
			}
		},
		errorPlacement: function ($error, $element) {
			var $box = false;
			if ($element.closest('.row-input').length || $element.closest('.customic-select-row').length) {					// inputy
				//console.log('error:1');
				$box = $element.closest('.validate-target');
				$error.addClass('label-error');
				$box.addClass('validate-error').removeClass('validate-ok');
				$box.after($error);
			}  else if ($element.closest('.checkbox-css').length) {			//mobile:checkbox o mobile:checkboxRow
				//console.log('error:2');
				$box = $element.closest('.validate-target');
				$error.addClass('label-error');
				$box.addClass('validate-error').removeClass('validate-ok');
				const id = $element.attr('id')
				if(id){
					$error.attr({
						id: id+'-error'	//ustawienie 'for' w tym miejscu nie działa
					});
				}
				$box.append($error);
			} else if ($element.closest('.e-payment-banks-list').length) {		// banki na wyborze płatności
				//console.log('error:3');
				$box = $element.closest('.row');
				$error.addClass('label-error');
				$box.addClass('validate-error').removeClass('validate-ok');
				$box.prepend($error);
			} else if ($element.closest('.delivery-time-hour-list').length) { 	// przedziały godzinowe
				//console.log('error:5');
				$box = $element.closest('.delivery-time-hour-list');
				$box.addClass('validate-error').removeClass('validate-ok');
				$box.prepend($error);
				$error.addClass('error label-error');
			} else if ($element.is('#inpost-point') || $element.is('#parcel-point-code')) {
				//console.log('error:7a', $error, $element);
				if($('#delivery-points-list .delivery-point.visible').length){
					$box = $('#delivery-points #delivery-points-list');
					$error.addClass('label-error');
					$box.addClass('validate-error').removeClass('validate-ok');
					$box.prepend($error);
				} else {
					$box = $('#delivery-points > .delivery-points-search .search-box');
					$error.addClass('label-error');
					$error.insertBefore($box);
				}
			} else if ($element.is('#city-code')) {								// miasto w dostawie do sklepu
				//console.log('error:7c', $error, $element);
				$box = $('#search-city');
				$error.insertBefore($box);
			} else if ($element.closest('.radio-group').length) { 				// lista płatności, standardowy lista radio
				//console.log('error:4');
				$box = $element.closest('.radio-group');
				$error.addClass('label-error');
				$box.addClass('validate-error').removeClass('validate-ok');
				$box.prepend($error);
			} else if ($element.closest('.row-textarea').length) { 				// row-textarea
				//console.log('error:9a');
				$box = $element.closest('.validate-target');
				$error.addClass('label-error');
				$box.addClass('validate-error').removeClass('validate-ok');
				$box.parent().append($error);
			} else if ($element.is('textarea')) { 								// nazwa firmy
				//console.log('error:9b');
				$box = $element.closest('.validate-target');
				$error.addClass('label-error');
				$box.addClass('validate-error').removeClass('validate-ok');
				$box.after($error);
			} else if ($element.is('#gift-card-value') || $element.is('#gift-card-custom-style') || $element.is('#predefined-wishes-selected')) { 			// prezentacja błędu na koncu bloczka validate-target, zamiast domyślnego na początku
				//console.log('error:6');
				$box = $element.closest('.validate-target');
				$error.addClass('label-error');
				$box.addClass('validate-error').removeClass('validate-ok');
				$box.append($error);
			} else if ($element.closest('.validate-target').length) { 			// domyślny validate-target
				//console.log('error:6');
				$box = $element.closest('.validate-target');
				$error.addClass('label-error');
				$box.addClass('validate-error').removeClass('validate-ok');
				$box.prepend($error);
			} else { 			// domyślne
				//console.log('error:8', $error, $element);
				$error.addClass('label-error');
				if ($error.length && $element.length) {
					$element.after($error);
				}
			}
		}
	};

	function scrollToError($validateTarget) {
		$box = $validateTarget || $('body').find('.error').eq(0).closest('.validate-target').first();
		if ($box.length) {
			scroll.to({
				$element: $($box),
				offsetTop: 'center'
			});
		}
	}

	function setOptions(options) {
		var obj = {};
		for (var i in defaults) {
			obj[i] = defaults[i];
		}
		return $.extend(true, obj, options);
	}

	function removeBackendError($input) {
		$input.closest('.validate-target')
			.siblings('.error-backend').remove();
	}

	var tasks = {
		errorForm: function (sendFunction) {
			var options = setOptions({
				submitHandler: function (form) {
					if ($(form).valid()) {
						sendFunction();
					}
				},
				rules: {
					"description": rules.messageTextarea,
					"email": {
						email: true,
						required: () => $("#error-subject").val() !== 'CONTENT_VIOLATION_ERROR'
					},
					"legalStatementSelected": rules.legalStatement,
					"g-recaptcha-response": rules.recaptcha
				},
				messages: {
					"description": messages.messageTextarea,
					"email": {
						email: "Podaj poprawny adres e-mail",
						required: "Wpisz adres e-mail"
					},
					"legalStatementSelected": messages.legalStatement,
					"g-recaptcha-response": messages.recaptcha
				}
			});
			$("#error-form").validate(options);
		},
		passwordRecovery: function (sendFunction) {
			var options = setOptions({
				submitHandler: function (form) {
					sendFunction(form);
				},
				rules: {
					"email": rules.email,
					"g-recaptcha-response": rules.recaptcha
				},
				messages: {
					"email": messages.email,
					"g-recaptcha-response": messages.recaptcha
				}
			});
			$("#password-recovery form").validate(options);
		},
		loginLayer: function (sendFunction) {
			var options = setOptions({
				submitHandler: function (form) {
					sendFunction();
				},
				rules: {
					"j_username": rules.email,
					"j_password": rules.password,
					"captcha": rules.captcha,
					"g-recaptcha-response": rules.recaptcha
				},
				messages: {
					"j_username": messages.email,
					"j_password": messages.password,
					"captcha": messages.captcha,
					"g-recaptcha-response": messages.recaptcha
				}
			});
			$("#login-form").validate(options);
		},
		registrationLayer: function (sendFunction) {
			var options = setOptions({
				submitHandler: function () {
					sendFunction();
				},
				rules: {
					password: rules.strongPassword,
					password2: rules.passwordNewRepeat,
					statuteAccepted: rules.termsAccepted,
					"g-recaptcha-response": rules.recaptcha
				},
				messages: {
					password2: messages.passwordNewRepeat,
					statuteAccepted: messages.termsAccepted,
					"g-recaptcha-response": messages.recaptcha
				}
			});
			$("#registration-form").validate(options);
		},
		login: function (sendFunction) {
			var $form = $("#login-box form");
			var options = setOptions({
				rules: {
					"j_username": rules.login,
					"j_password": rules.password,
					"captcha": rules.captcha
				},
				messages: {
					"j_username": messages.login,
					"j_password": messages.password,
					"captcha": messages.captcha
				},
				submitHandler: function () {
					sendFunction($form);
				}
			});
			$form.validate(options);
		},
		registration: function (sendFunction) {
			var $form = $("#registration-box form");
			var options = setOptions({
				rules: {
					"firstname": rules.firstname,
					"surname": rules.surname,
					"email": rules.email,
					"password": rules.strongPassword,
					"password2": rules.passwordNewRepeat,
					"statuteAccepted": rules.termsAccepted
				},
				messages: {
					"firstname": messages.firstname,
					"surname": messages.surname,
					"email": messages.email,
					"password2": messages.passwordNewRepeat,
					"statuteAccepted": messages.termsAccepted
				},
				submitHandler: function () {
					sendFunction($form);
				}
			});
			$form.validate(options);
		},
		guestKMELogin: function (sendFunction) {
			var $form = $("#guest-kme-login form");
			var options = setOptions({
				rules: {
					"email": rules.email,
					"orderNumber": {
						required: true
					}
				},
				messages: {
					"email": messages.email,
					"orderNumber": {
						required: 'Nr zamówienia jest wymagany'
					}
				},
				submitHandler: function () {
					sendFunction($form);
				}
			});
			$form.validate(options);
		},
		changePassword: function (sendFunction) {
			var options = setOptions({
				rules: {
					"password1": rules.strongPassword,
					"password2": rules.passwordNewRepeat
				},
				messages: {
					"password2": messages.passwordNewRepeat
				},
			});
			$("#change-password form").validate(options);
		},
		basket: function () {
			var options = setOptions({
				rules: {
					"deliveryType": rules.deliveryType,
					"voucherData.code": rules.voucherCode
				},
				messages: {
					"deliveryType": messages.deliveryType,
					"voucherData.code": messages.voucherCode
				}
			});
			$("#basket #container form:eq(0)").validate(options);
		},
		payment: function () {
			var options = setOptions({
				rules: {
					'paymentType': rules.paymentType,
					'eTransferBankId': rules.ePaymentBank,
					'instalmentShopCode': rules.shopCode,
					'instalmentCityCode': rules.cityCode,
					'termsAccepted': rules.termsAccepted,
					'giftCardNumber': rules.giftCardNumber,
					'giftCardPin': rules.giftCardPin,
					'deliveryTimeAccepted': {
						required: true
					}
				},
				messages: {
					'paymentType': messages.paymentType,
					'eTransferBankId': messages.ePaymentBank,
					'instalmentShopCode': messages.shopCode,
					'instalmentCityCode': messages.cityCode,
					'termsAccepted': messages.termsAccepted,
					'giftCardNumber': messages.giftCardNumber,
					'giftCardPin': messages.giftCardPin,
					'deliveryTimeAccepted': "Przed potwierdzeniem Zamówienia/rezerwacji zaakceptuj termin realizacji"
				}
			});
			$("#payment #container form:eq(0)").validate(options);
		},
		changePayment: function (params) {
			var options = setOptions({
				rules: {
					"deliveryInterval": { required: true },
					"ePaymentBankId": { required: true },
					"termsAccepted": { required: true },	// formularz jest dla "zmiany płatności" ale także dla ścieżki negatywnej PAYy i tam jest inne pole na zgody
					"paymentOperatorAgreementAccepted": { required: true }
				},
				messages: {
					"deliveryInterval": "Wybierz dzień i przedział godzinowy",
					"ePaymentBankId": "Wybierz bank",
					"termsAccepted": "Wybór sposobu płatności wymaga akceptacji regulaminu",
					"paymentOperatorAgreementAccepted": "Wybór sposobu płatności wymaga akceptacji regulaminu"
				},
				submitHandler: function (form) {
					params.send();
				},
			});
			params.$form.validate(options);
		},
		giftCardPayment: function () {
			var options = setOptions({
				rules: {
					'paymentType': rules.paymentType,
					'eTransferBankId': rules.ePaymentBank,
					'termsAccepted': rules.termsAccepted
				},
				messages: {
					'paymentType': messages.paymentType,
					'eTransferBankId': messages.ePaymentBank,
					'termsAccepted': messages.termsAccepted
				}
			});
			$('#gift-card-payment #container form:eq(0)').validate(options);
		},
		deliveryTime: function () {
			var form = $("#delivery-time #container form:eq(0)");
			var defaultSuccess = defaults.success;
			var defaultErrorPlacement = defaults.errorPlacement;
			var defaultInvalidHandler = defaults.invalidHandler;
			var options = setOptions({
				rules: {
					"deliveryTimeAccepted": {
						required: true
					},
					"deliveryTimeGroup": rules.deliveryTimeGroup,
					"interval": rules.interval,
					"termsAccepted": rules.termsAccepted,
					"deliveryCostAccepted": rules.deliveryCostAccepted,
					'paymentType': rules.paymentType,			//wszystkie poniższe dotyczą dodatkowej płatności na K5
					'instalmentBank': rules.ePaymentBank,
					'eTransferBankId': rules.ePaymentBank,
					'instalmentShopCode': rules.shopCode,
					'instalmentCityCode': rules.cityCode,
					'termsAccepted': rules.termsAccepted,
					'supplementPaymentType': { required: true }
				},
				messages: {
					"deliveryTimeAccepted": "Przed potwierdzeniem Zamówienia/rezerwacji zaakceptuj termin realizacji",
					"deliveryTimeGroup": messages.deliveryTimeGroup,
					"termsAccepted": messages.termsAccepted,
					"deliveryCostAccepted": messages.deliveryCostAccepted,
					'paymentType': messages.paymentType,		//wszystkie poniższe dotyczą dodatkowej płatności na K5
					'instalmentBank': messages.ePaymentBank,
					'eTransferBankId': messages.ePaymentBank,
					'instalmentShopCode': messages.shopCode,
					'instalmentCityCode': messages.cityCode,
					'termsAccepted': messages.termsAccepted,
					'supplementPaymentType': { required: 'Wybierz sposób płatności' }
				}
			});
			form.validate(options);
		},

	chooseDelivery: function ({ deliveryType, emailRequiredValidationEnabled, isPolishAddressRequired, isPolishCustomerPhoneNumberRequired, isPolishReceiverPhoneNumberRequired }) {
			let form = $("#choose-delivery-form");
			var options = setOptions({
				rules: {
					"orderUser.firstname": rules.firstname,
					"orderUser.surname": rules.surname,
					"orderUser.frontUserType": rules.userType,
					"orderUser.companyName": rules.companyName,
					"orderUser.email": emailRequiredValidationEnabled ? rules.email : { email: true },
					"orderUser.account.password": rules.passwordRegistration,
					"orderUser.account.password2": rules.passwordNewRepeat,
					"orderUser.phoneCountryCode": {
						phoneCountryCode: () => ({ isPolishPhoneNumberRequired: isPolishCustomerPhoneNumberRequired })
					},
					"orderUser.homeAddress.countryCode": {
						countryCode: () => ({ isPolishAddressRequired })
					},
					"orderUser.homeAddress.street": rules.street,
					"orderUser.homeAddress.houseNumber": rules.houseNumber,
					"orderUser.homeAddress.flatNumber": rules.flat,
					"orderUser.homeAddress.zipCode": {
						required: true,
						zipCode: () => ({ isForeignCountryCode: $('#country-code').val() !== 'PL' })
					},
					"orderUser.homeAddress.city": rules.city,
					"orderUser.nip": rules.nip,
					"orderUser.vatUe": rules.vatUe,
					"orderUser.numberId": rules.numberId,
					"orderUser.companyCountryCode": {
						required() {
							return form.find('#tax-identifier-selector').val() === 'VAT_UE';
						}
					},
					"orderUser.phone": {
						required: true,
						maxlength: () => $('#phone-country-code-selector').val() !== "+48" ? 13 : 9,
						phone: () => ({ isForeignPhoneNumber: $('#phone-country-code-selector').val() !== "+48" })
					},

					"receiver.firstName": rules.firstname,
					"receiver.surname": rules.surname,
					"receiver.phoneCountryCode": () => ({ isPolishPhoneNumberRequired: isPolishReceiverPhoneNumberRequired }),
					"receiver.phone": {
						required: true,
						maxlength: () => $('#receiver-phone-country-code-selector').val() !== "+48" ? 13 : 9,
						phone: () => ({ isForeignPhoneNumber: $('#receiver-phone-country-code-selector').val() !== "+48" })
					},
					"deliveryAddress.street": rules.street,
					"deliveryAddress.houseNumber": rules.houseNumber,
					"deliveryAddress.flatNumber": rules.flat,
					"deliveryAddress.zipCode": rules.zipCode,
					"deliveryAddress.city": rules.city,

					"invoice.firstName": rules.firstname,
					"invoice.surname": rules.surname,
					"invoice.companyName": rules.companyName,
					"invoice.nip": rules.nip,
					"invoice.countryCode": {
						countryCode: () => ({ isPolishAddressRequired })
					},
					"invoice.vatUe": rules.vatUe,
					"invoice.numberId": rules.numberId,
					"invoice.companyTaxIdType": {
						companyTaxIdType: () => ({isPolishAddressRequired})
					},
					"invoice.companyCountryCode": {
						required() {
							return form.find('#invoice-tax-identifier-selector').val() === 'VAT_UE';
						},
						companyCountryCode: () => ({
							isPolishAddressRequired,
							taxIdType: form.find('#invoice-tax-identifier-selector').val()
						})
					},
					"invoice.street": rules.street,
					"invoice.houseNumber": rules.houseNumber,
					"invoice.flatNumber": rules.flat,
					"invoice.zipCode": {
						required: true,
						zipCode: () => ({ isForeignCountryCode: $('#invoice-country-code').val() !== 'PL' })
					},
					"invoice.city": rules.city,

					"additionalInvoice.companyName": rules.companyName,
					"additionalInvoice.employeeName": rules.employeeName,
					"additionalInvoice.nip": rules.nip,
					"additionalInvoice.vatUe": rules.vatUe,
					"additionalInvoice.numberId": rules.numberId,
					"additionalInvoice.internalId": rules.internalId,
					"additionalInvoice.taxIdType": {
						companyTaxIdType: () => ({isPolishAddressRequired})
					},
					"additionalInvoice.taxIdCountryCode": {
						required() {
							return form.find('#additional-invoice-tax-identifier-selector').val() === 'VAT_UE';
						},
						companyCountryCode: () => ({
							isPolishAddressRequired,
							taxIdType: form.find('#additional-invoice-tax-identifier-selector').val()
						})
					},
					"additionalInvoice.countryCode": {
						countryCode: () => ({isPolishAddressRequired})
					},
					"additionalInvoice.street": rules.street,
					"additionalInvoice.houseNumber": rules.houseNumber,
					"additionalInvoice.flatNumber": rules.flat,
					"additionalInvoice.zipCode":  {
						required: true,
						zipCode: () => ({ isForeignCountryCode: $('#additional-invoice-country-code').val() !== 'PL'})
					},
					"additionalInvoice.city": rules.city,
					"additionalInvoice.percentageShare": rules.percentageShare,
					"additionalInvoice.roleDescription": rules.roleDescription,
					"additionalInvoice.email": rules.email,

					"termsAccepted": rules.termsAccepted,
					"requestToProvideDigitalTypeProductAtOnceNoticeAccepted": rules.requestToProvideDigitalTypeProductAtOnceNoticeAccepted,
					"requestToProvideServiceAtOnceNoticeAccepted": rules.requestToProvideServiceAtOnceNoticeAccepted,

					"delivery.shopCode": rules.shopCode,
					"delivery.cityCode": rules.cityCode,
					"delivery.localization": rules.localization,
					"delivery.parcelMachineCode": rules.parcelMachineCode,
					"delivery.pickupPointCode": rules.parcelPointCode,
					"pofficeZipCode": rules.pofficeZipCode,
					"poffice": rules.poffice,

					"deliveryTimeAccepted": { required: true },

					"partnerSubscriptionsContactDetails.termsAccepted": { required: true },
					"partnerSubscriptionsContactDetails.firstName": rules.firstname,
					"partnerSubscriptionsContactDetails.lastName": rules.surname,
					"partnerSubscriptionsContactDetails.contactPhone": rules.phone,

					"digitalProductTypePermissions.productRegulationsAccepted": rules.digitalProductTypeProductRegulationsAccepted,
					"digitalProductTypePermissions.recurringPaymentsRegulationsAccepted": rules.digitalProductTypeRecurringPaymentsRegulationsAccepted
				},
				messages: {
					"orderUser.firstname": messages.firstname,
					"orderUser.surname": messages.surname,
					"orderUser.frontUserType": messages.userType,
					"orderUser.companyName": messages.companyName,
					"orderUser.email": messages.email,
					"orderUser.account.password": messages.password,
					"orderUser.account.password2": "",
					"orderUser.homeAddress.street": messages.street,
					"orderUser.homeAddress.houseNumber": messages.houseNumber,
					"orderUser.homeAddress.flatNumber": messages.flat,
					"orderUser.homeAddress.zipCode": messages.zipCode,
					"orderUser.homeAddress.city": messages.city,
					"orderUser.nip": messages.nip,
					"orderUser.vatUe": messages.vatUe,
					"orderUser.numberId": messages.numberId,
					"orderUser.companyCountryCode": messages.countryCode,
					"additionalInvoice.email": {
						required: "Podaj adres e-mail",
					},
					"orderUser.phone": $.extend({}, messages.phone, {
						maxlength(length) {
							if ($('#phone-country-code-selector').val() === '+48') {
								return 'Podaj poprawny numer telefonu';
							} else {
								return `Podaj nie więcej niż ${length} znaków`;
							}
						}
					}),

					"receiver.firstName": messages.firstname,
					"receiver.surname": messages.surname,
					"receiver.phone": $.extend({}, messages.phone, {
						maxlength(length) {
							if ($('#receiver-phone-country-code-selector').val() === '+48') {
								return 'Podaj poprawny numer telefonu';
							} else {
								return `Podaj nie więcej niż ${length} znaków`;
							}
						}
					}),
					"deliveryAddress.street": messages.street,
					"deliveryAddress.houseNumber": messages.houseNumber,
					"deliveryAddress.flatNumber": messages.flat,
					"deliveryAddress.zipCode": messages.zipCode,
					"deliveryAddress.city": messages.city,

					"invoice.firstName": messages.firstname,
					"invoice.surname": messages.surname,
					"invoice.companyName": messages.companyName,
					"invoice.nip": messages.nip,
					"invoice.vatUe": messages.vatUe,
					"invoice.numberId": messages.numberId,
					"invoice.street": messages.street,
					"invoice.houseNumber": messages.houseNumber,
					"invoice.flatNumber": messages.flat,
					"invoice.zipCode": messages.zipCode,
					"invoice.city": messages.city,
					"invoice.companyCountryCode": messages.countryCode,

					"additionalInvoice.nip": messages.nip,
					"additionalInvoice.vatUe": messages.vatUe,
					"additionalInvoice.numberId": messages.numberId,
					"additionalInvoice.internalId": messages.internalId,
					"additionalInvoice.street": messages.street,
					"additionalInvoice.companyName": messages.companyName,
					"additionalInvoice.houseNumber": messages.houseNumber,
					"additionalInvoice.flatNumber": messages.flat,
					"additionalInvoice.zipCode": messages.zipCode,
					"additionalInvoice.city": messages.city,
					"additionalInvoice.taxIdCountryCode": messages.countryCode,
					"additionalInvoice.percentageShare": messages.percentageShare,
					"additionalInvoice.roleDescription": messages.roleDescription,

					"termsAccepted": messages.termsAccepted,
					"requestToProvideDigitalTypeProductAtOnceNoticeAccepted": messages.requestToProvideDigitalTypeProductAtOnceNoticeAccepted,
					"requestToProvideServiceAtOnceNoticeAccepted": messages.requestToProvideServiceAtOnceNoticeAccepted,

					"delivery.shopCode": messages.shopCode,
					"delivery.cityCode": messages.cityCode,
					"delivery.localization": { required: (deliveryType == 'inpost' ? "Użyj wyszukiwarki aby wybrać Paczkomat®" : "Użyj wyszukiwarki aby wybrać punkt odbioru ") },
					"delivery.parcelMachineCode": messages.parcelMachineCode,
					"delivery.pickupPointCode": messages.parcelPointCode,
					"pofficeZipCode": messages.pofficeZipCode,
					"poffice": messages.poffice,

					"deliveryTimeAccepted": { required: "Czas realizacji musi zostać zaakceptowany" },

					"partnerSubscriptionsContactDetails.firstName": messages.firstname,
					"partnerSubscriptionsContactDetails.lastName": messages.surname,

					"digitalProductTypePermissions.productRegulationsAccepted": messages.digitalProductTypeProductRegulationsAccepted,
					"digitalProductTypePermissions.recurringPaymentsRegulationsAccepted": messages.digitalProductTypeRecurringPaymentsRegulationsAccepted
				}
			});
			form.validate(options);
			$('input[name^="insurance.insurerNameToReadStatus"]').each(function (index, element) {
				$(element).rules("add", {
					required: $(element).hasClass('subscription-regulation') ? rules.warrantySubscriptionRegulations : rules.warrantyRegulations,
					messages: $(element).hasClass('subscription-regulation') ? messages.warrantySubscriptionRegulations : messages.warrantyRegulations
				});
			});
		},
		giftCardDelivery: function () {
			var options = setOptions({
				rules: {
					"orderUser.firstname": rules.firstname,
					"orderUser.surname": rules.surname,
					"orderUser.phone": {
						required: true,
						maxlength: () => $('#phone-country-code-selector').val() !== "+48" ? 13 : 9,
						phone: () => ({ isForeignPhoneNumber: $('#phone-country-code-selector').val() !== "+48" })
					},
					"termsAccepted": rules.termsAccepted
				},
				messages: {
					"orderUser.firstname": messages.firstname,
					"orderUser.surname": messages.surname,
					"orderUser.phone": messages.phone,
					"termsAccepted": messages.termsAccepted
				}
			});
			$('#choose-delivery-form').validate(options);
		},
		delivery: function (sendFunction) {
			var options = setOptions({
				submitHandler: function (form) {
					sendFunction(form);
				},
				/*onkeyup: function (el) {
					var isFormValid = $('#delivery-form').valid();
					$('#delivery-save-btn').prop('disabled', !isFormValid);
				},*/
				rules: {

					"addLine1": rules.firstname,
					"addLine2": rules.surname,
					"zipCode": rules.zipCode,
					"city": rules.city,
					"street": rules.street,
					"houseNumber": rules.houseNumber,
					"flatNumber": rules.flat
				},
				messages: {
					"addLine1": messages.firstname,
					"addLine2": messages.surname,
					"zipCode": messages.zipCode,
					"city": messages.city,
					"street": messages.street,
					"houseNumber": messages.houseNumber,
					"flatNumber": messages.flat
				}
			});
			$('#delivery-form').validate(options);
		},
		giftCardOrderSelection: function (sendFunction) {
			var $form = $('#front-form');
			var options = $.extend(true, defaults, {
				rules: {
					"value": rules.giftCardValue
				},
				messages: {
					"value": messages.giftCardValue
				}
			});
			$form.validate(options);
		},
		giftCardPersonalization: function (sendFunction) {
			var $form = $('#gift-card-customization-form');
			var options = $.extend(true, defaults, {
				rules: {
					"giftCardCustomStyle": {
						required: true
					},
					"predefinedWishesSelected": {
						required: function () {
							return $('#predefined-wishes', $form).is(':checked');
						}
					},
					"greetings": {
						required: function () {
							return $('#custom-wishes', $form).is(':checked');
						}
					},
					"customWishesTermsAccepted": {
						required: function () {
							return $('#custom-wishes', $form).is(':checked');
						}
					},
					"customWishesContentAgreement": {
						required: function () {
							return $('#custom-wishes', $form).is(':checked');
						}
					},
				},
				messages: {
					"giftCardCustomStyle": {
						required: "Wybierz wzór karty podarunkowej"
					},
					"predefinedWishesSelected": {
						required: "Wybierz życzenia"
					},
					"greetings": {
						required: "Podaj treść życzeń"
					},
					"customWishesTermsAccepted": messages.termsAccepted,
					"customWishesContentAgreement": {
						required: "Wyrażenie zgody jest wymagane"
					}
				}
			});
			$form.validate(options);
		}

	};

	var methods = {
		firstname: function (value, element) {
			// pierwsza litera jest dozwoloną literą
			// pozostałe 34 znaki mogą być literą, spacją i myślnikiem
			return /^[a-zA-ZąćęłńóśżźĄĆĘŁŃÓŚŻŹ']{1}[a-zA-ZąćęłńóśżźĄĆĘŁŃÓŚŻŹ\- ']{1,39}$/.test(value) && !/.[\s]{2,}/.test(value) && !/.[-]{2,}/.test(value);
		},
		surname: function (value, element) {
			// pierwsza litera jest dozwoloną literą
			// pozostałe 34 znaki mogą być literą, spacją i myślnikiem
			return /^[a-zA-ZąćęłńóśżźĄĆĘŁŃÓŚŻŹ']{1}[a-zA-ZąćęłńóśżźĄĆĘŁŃÓŚŻŹ\- ']{1,39}$/.test(value) && !/.[\s]{2,}/.test(value) && !/.[-]{2,}/.test(value);
		},
		employeeName(value, element) {
			// Walidacja jak dla nazwy firmy
			return methods.companyName(value, element);
		},
		phone: function (value, element, params) {
			if (typeof params === 'object' && params.isForeignPhoneNumber) {
				return true; // pomijamy walidację dla zagranicznych numerów
			}
			var number = value + '';
			var numberValue = number.match(/\d/g);
			if (numberValue !== null && numberValue.length === 9) {
				return true;
			}
		},
		street: function (value, element) {
			var testReg1 = new RegExp("^[0-9a-zA-ZąćęłńóśżźĄĆĘŁŃÓŚŻŹ\\- .']{2,60}$");	//dozwolone znaki
			var testReg2 = new RegExp("[a-zA-ZąćęłńóśżźĄĆĘŁŃÓŚŻŹ]+");					//min jedna litera
			return testReg1.test(value) && testReg2.test(value);
		},
		countryCode(value, element, params) {
			if (typeof params === 'object' && params.isPolishAddressRequired) {
				return value === 'PL';
			}
			return true;
		},
		companyTaxIdType(value, element, params) {
			if (typeof params === 'object' && params.isPolishAddressRequired) {
				return value === 'NIP' || value === 'NUMBER_ID' || value === 'EMPTY_ID' || value === 'INTERNAL_ID';
			}
			return true;
		},
		companyCountryCode(value, element, params) {
			// w przypadku UPC/ESD pole kraju musi być puste
			if (typeof params === 'object' && params.isPolishAddressRequired && params.taxIdType === 'NUMBER_ID') {
				return value === '';
			}
			return true;
		},
		phoneCountryCode(value, element, params) {
			if (typeof params === 'object' && params.isPolishPhoneNumberRequired) {
				return value === '+48';
			}
			return true;
		},
		zipCode: function (value, element, params) {
			const formatZipCode = zipCode => `${zipCode.substr(0, 2)}-${zipCode.substr(2, 3)}`;

			if (typeof params === "object" && params.isForeignCountryCode) {
				return /^[a-zA-Z0-9\- ]{0,8}$/.test(value);
			}

			let status = true;
			const zipCode = value.replace(/[\ \-]/gi, "");

			if (/\d{5}/.test(zipCode) && zipCode.length >= 5) {
				$(element).val(formatZipCode(zipCode));
			} else {
				status = false;
			}

			return status;
		},
		city: function (value, element) {
			return /^[a-zA-ZąćęłńóśżźĄĆĘŁŃÓŚŻŹ\- .]{2,40}$/.test(value);
		},
		companyName: function (value, element) {
			var result = value.split('').filter(function (y) {
				let char = y.charCodeAt();
				return char > 20 && char < 383;
			});
			return result.length === value.length;
		},
		houseNumber: function (value, element) {
			if (value.length > 10) {
				return false;
			} else if (/[1-9]/.test(value) && !/;/.test(value) && /^[^\-].*/.test(value)) {	// min 1 cyfra, brak średnika, nie zaczyna się od "-"
				return true;
			}
			return false;
		},
		flat: function (value, element) {
			if (value.length > 10) {
				return false;
			} else if (!/;/.test(value) && /^[^\-].*/.test(value)) {	// brak średnika, nie zaczyna się od "-"
				return true;
			}
			return false;
		},
		viesVerified: function(value, element) {
			return element.classList.contains('is-verified');
		},
		numberId(value, el) {
			return /^[^\s]{1,50}$/.test(value);
		},
		vatUe: function (value, element) {
			var rules = ''+$(element).data('nip-rules');
			return value && value.length && rules && rules.length ? new RegExp(rules, "g").test(value) : false;
		},
		internalId(value, element) {
			if (value && value.length) {
				const parts = value.split('-');
				if (parts.length !== 2) {
					return false;
				}
				const [nip, id] = parts;
				if (nip.length !== 10) {
					return false;
				}
				return methods.nipValidator(nip) && /^\d{5}$/.test(id); // np. 5270005984-12345 - pierwsza część przed myślnikiem spełnia warunki dla NIP
			}
			return false;
		},
		percentageShare(value, element) {
			if (value && value.length && /^\d{1,3}([,.]\d{1,6})?$/.test(value)) { // np. 25,50 % (max 9 cyfr w tym max 6 miejsc po przecinku lub kropce)
				return parseFloat(value.replace(',', '.')) <= 100;
			}
			return false;
		},
		nipValidator(nip) {
			var verificator_nip = new Array(6, 5, 7, 2, 3, 4, 5, 6, 7);
			var n = 0;
			var ile;
			for (var i = 0; i < 9; i++) {
				ile = nip.charAt(i) / 1 * verificator_nip[i] / 1;
				n += ile;
			}
			// walidacja odrzuca nip z samymi zerami
			if (n === 0) {
				return false;
			}
			// czy wszystkie cyfry są takie same
			const allDigitsSame = nip.split('').every(digit => digit === nip[0]);
			if (allDigitsSame) {
				return false;
			}
			n %= 11;
			if (n != nip.charAt(9)) {
				return false;
			} else {
				return true;
			}
		},
		nip: function (value, element) {
			var status = false;
			if (jQuery(element).val() === "") {
				status = true;
			} else {
				var nip = value.replace(/[\ _\-]/gi, "");
				if (/\d{3}-\d{2}-\d{2}-\d{3}/.test(value) || /\d{3}-\d{3}-\d{2}-\d{2}/.test(value) || /\d{10}/.test(value)) {
					status = true;
					if (nip.length != 10) {
						status = false;
					} else {
						status = methods.nipValidator(nip);
						if (status === true && !/\d{3}-\d{3}-\d{2}-\d{2}/.test(value)) {
							jQuery(element).val(nip.substr(0, 3) + "-" + nip.substr(3, 2) + "-" + nip.substr(5, 2) + "-" + nip.substr(7, 3));
						}
					}
				} else {
					status = false;
				}
			}
			return status;
		},
		trim: function (value, element) {
			return $.trim(value) ? true : false;
		},
		voucherCode: function (value, element) {
			if (value.length == 0 || /^[0-9a-zA-Z.-]+$/.test(value)) {
				return true;
			}
			return false;
		},
		strongPassword: function () {
			return passwordInvalid.check();
		}
	};

	function task(name, params) {
		if (name && tasks[name]) {
			tasks[name](params);
			scrollToError();
		}
	}

	function element($element, $form) {
		if ($element.length && $form.length && $form.data('validator')) {
			$form.validate().element($element);
			console.log('Walidacja zakończona', {
				$element: $element,
				$form: $form
			});
			return;
		}

		console.log('Walidacja nieudana, nie znaleziono pola lub formularza', {
			$element: $element,
			$form: $form
		});
	}

	function off($form) {
		$form.find('input, select').ignore(true);
	}
	var addedMethods = [
		["firstname", "Imię zawiera niepoprawne znaki"],
		["surname", "Nazwisko zawiera niepoprawne znaki"],
		["employeeName", "Podaj poprawne imię i nazwisko pracownika"],
		['city', 'Podaj poprawną nazwę miejscowości'],
		['companyName', 'Nazwa firmy zawiera niepoprawne znaki'],
		['nip', 'Podaj poprawny NIP w formacie xxx-xx-xx-xxx'],
		['vatUe', 'Podaj poprawny numer VAT UE'],
		['internalId', 'Podaj poprawne ID Wewnętrzne'],
		['percentageShare', 'Podaj poprawny Udział'],
		['viesVerified', 'Numer VAT UE nie został poprawnie zweryfikowany'],
		['numberId', 'Podaj poprawny Numer ID'],
		['phone', 'Podaj poprawny numer telefonu'],
		['street', 'Ulica zawiera niepoprawne znaki'],
		['zipCode', 'Podaj poprawny kod pocztowy'],
		['countryCode', 'Podaj polski adres'],
		['companyTaxIdType', 'Podaj dane polskiej firmy'],
		['phoneCountryCode', 'Podaj polski prefix'],
		['voucherCode', 'Kod rabatowy zawieran niedozwolone znaki'],
		['trim', 'Pole nie może być wypełnione tylko spacjami'],
		['houseNumber', 'Podaj poprawny numer domu'],
		['flat', 'Podaj poprawny numer mieszkania'],
		['strongPassword', 'Hasło nie spełnia zasad polityki haseł', true],
		['companyCountryCode', 'Nie sprzedajemy usług cyklicznych na identyfikatory podatkowe powiązane z zagranicą.']
	];
	$(document).ready(function () {
		$(addedMethods).each(function (i, n) {
			var fn = methods[n[0]];
			$.validator.addMethod(n[0], function (value, element, param) {
				if (n[2]) {
					return fn(value, element, param);
				} else {
					return this.optional(element) || fn(value, element, param);
				}
			}, n[1]);
		});
	});
	return {
		task,
		element,
		off,
		scrollToError,
		removeBackendError
	};
});
